import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // No scroll to top for "/home"
    if (pathname && pathname.indexOf('home') != 1) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}